import React, { useState } from "react";
import { Link } from "react-router-dom";
import Logo from "../../assets/images/logo.png";
import CustomLink from "./customLink";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faInstagram,
  faWhatsapp,
  faTiktok,
  faSnapchat,
} from "@fortawesome/free-brands-svg-icons";
import {
  EnvelopeIcon,
  PaperAirplaneIcon,
  ChevronUpIcon,
} from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";
import kuwatFlag from "../../assets/images/flagKuawit.webp";
import flagErupa from "../../assets/images/flagErupa.webp";
import flagTrukey from "../../assets/images/turkey.webp";
import { useDispatch } from "react-redux";
import { subscribeUser } from "../../redux/reducer/subscribeReducer ";
import useLanguageDirection from "../../hooks/useLanguageDirection";
import { useLanguageNavigate } from "../../hooks/useLanguageNavigation";
import SubscriptionPopup from "./SubscriptionPopup";

export default function FooterUser() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [popupType, setPopupType] = useState("success");
  const navigateWithLang = useLanguageNavigate();
  const direction = useLanguageDirection();

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const result = await dispatch(subscribeUser(email)).unwrap();

      setPopupType("success");
      setShowPopup(true);
      setEmail("");

      setTimeout(() => {
        setShowPopup(false);
      }, 2000);
    } catch (error) {
      setPopupType("error");
      setShowPopup(true);

      setTimeout(() => {
        setShowPopup(false);
      }, 2000);
    }
  };

  return (
    <div className="bg-black">
      <div dir={direction} className=" max-container">
        <hr className="h-0.5 border-t-0 opacity-100 dark:opacity-50" />
        <footer className="px-3 py-4 my-5 text-center px:custom-mobile-padding max-container">
          <div className="">
            <div className="flex flex-row flex-wrap justify-between h-full gap-y-5">
              <div className="flex flex-col justify-between w-full gap-3 lg:w-3/12 md:w-6/12 sm:w-6/12">
                <Link to="/">
                  <img
                    src={Logo}
                    alt="Logo"
                    className="md:w-auto md:h-auto w-[161px] h-[60px]"
                  />
                </Link>
                <p
                  className="text-sm font-medium text-white text-start"
                  dangerouslySetInnerHTML={{
                    __html: t("logo_description").replace(/\n/g, "<br />"),
                  }}
                />
                <div className="flex items-center">
                  <a
                    href="https://api.whatsapp.com/send/?phone=%2B905331586084&text&type=phone_number&app_absent=0"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FontAwesomeIcon
                      icon={faWhatsapp}
                      className="me-5 text-custom-yellow"
                    />
                  </a>
                  <a
                    href="https://www.facebook.com/MarkaShipp"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FontAwesomeIcon
                      icon={faFacebookF}
                      className="me-5 text-custom-yellow"
                    />
                  </a>
                  <a
                    href="https://www.tiktok.com/@markaship_"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FontAwesomeIcon
                      icon={faTiktok}
                      className="me-5 text-custom-yellow"
                    />
                  </a>
                  <a
                    href="https://snapchat.com/t/FLKCIBjh"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FontAwesomeIcon
                      icon={faSnapchat}
                      className="me-5 text-custom-yellow"
                    />
                  </a>
                  <a
                    href="https://www.instagram.com/markaship_"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FontAwesomeIcon
                      icon={faInstagram}
                      className="me-5 text-custom-yellow"
                    />
                  </a>
                </div>
              </div>

              <div className="flex flex-col justify-between w-full gap-3 lg:w-2/12 md:w-3/12">
                <h6 className="text-xl font-bold uppercase md:mt-6 md:mb-2 text-custom-yellow text-start">
                  {t("company")}
                </h6>
                <div className="">
                  <CustomLink to="/terms-conditions">
                    {t("privacySection.termsAndCommitments")}
                  </CustomLink>
                </div>
                <div className="">
                  <CustomLink to="/packaging-and-shipments">
                    {t("ShipmentPackaging")}
                  </CustomLink>
                </div>
                <div className="">
                  <CustomLink to="/quality-control-and-shipment-photography">
                    {t("privacySection.title")}
                  </CustomLink>
                </div>
                {/* </div> */}
              </div>

              <div className="flex flex-col justify-between w-full gap-3 lg:w-2/12 md:w-3/12">
                <h6 className="text-xl font-bold uppercase md:mt-6 md:my-2 md:m-0 text-custom-yellow text-start">
                  {t("quick_links")}
                </h6>
                <div className="">
                  <CustomLink to="/our-services">
                    {t("our_services")}
                  </CustomLink>
                </div>
                <div className="">
                  <CustomLink to="/privacy-policy">
                    {t("privacy_policy")}
                  </CustomLink>
                </div>

                <div className="">
                  <CustomLink to="/shipping-insurance">
                    {t("shippingInsurance.title")}
                  </CustomLink>
                </div>
              </div>

              <div className="flex flex-col justify-between w-full gap-3 lg:w-2/12 md:w-3/12">
                <h6 className="text-xl font-bold uppercase md:mt-6 md:my-2 md:m-0 text-custom-yellow text-start">
                  {t("contactUs")}
                </h6>
                <p className="flex items-center text-sm text-gray-500">
                  <img src={kuwatFlag} alt="Background" className="w-5 mx-2" />
                  <a
                    onClick={() => navigateWithLang("/contact-us")}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="font-medium text-white duration-300 cursor-pointer text-xxs lg:text-sm hover:text-custom-yellow"
                  >
                    {t("addressOne")}
                  </a>
                </p>
                <p className="flex items-center text-sm text-gray-500">
                  <img src={flagErupa} alt="Background" className="w-5 mx-2" />
                  <a
                    onClick={() => navigateWithLang("/contact-us")}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="font-medium text-white duration-300 cursor-pointer text-xxs lg:text-sm hover:text-custom-yellow"
                  >
                    {t("addressTwo")}
                  </a>
                </p>
                <p className="flex items-center text-sm text-gray-500">
                  <img src={flagTrukey} alt="Background" className="w-5 mx-2" />
                  <a
                    onClick={() => navigateWithLang("/contact-us")}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="font-medium text-white duration-300 cursor-pointer text-xxs lg:text-sm hover:text-custom-yellow"
                  >
                    {t("addressThree")}
                  </a>
                </p>
                <p className="flex items-center text-sm text-gray-500">
                  <EnvelopeIcon className="w-4 h-4 mx-2 text-custom-yellow" />
                  <a
                    href="mailto:support@markaship.com"
                    className="font-medium text-white duration-300 text-xxs lg:text-sm hover:text-custom-yellow"
                  >
                    support@markaship.com
                  </a>
                </p>
                {/* </div> */}
              </div>

              <div className="justify-between w-full gap-3 sm:w-6/12 lg:w-3/12 md:w-6/12">
                <h6 className="text-xl font-bold uppercase md:mt-6 md:my-2 md:m-0 text-custom-yellow text-start">
                  {t("SubscribetToOurNewsletter")}
                </h6>
                <p
                  className="mb-6 text-sm font-medium text-white text-start"
                  dangerouslySetInnerHTML={{
                    __html: t("Subscribet_description").replace(
                      /\n/g,
                      "<br />"
                    ),
                  }}
                />
                <form onSubmit={handleSubmit} className="mt-auto">
                  <div className="relative" dir={direction}>
                    <span
                      className={`absolute inset-y-0 flex items-center text-gray-900 ${
                        direction === "rtl" ? "left-2" : "right-2"
                      }`}
                    >
                      <button type="submit">
                        <PaperAirplaneIcon
                          className={`h-8 w-8 md:h-9 md:w-9 text-black bg-custom-yellow rounded-sm ${
                            direction === "rtl" ? "rotate-[180deg]" : ""
                          }`}
                        />
                      </button>
                    </span>
                    <input
                      type="email"
                      placeholder={t("Enter_your_email_address")}
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      className={`w-full px-5 py-3  text-white text-base sm:text-lg border border-custom-yellow rounded-sm bg-transparent 
                      placeholder:text-base sm:placeholder:text-base`}
                    />
                  </div>
                </form>
              </div>
            </div>
          </div>
        </footer>
      </div>

      <div
        className="py-2 text-center text-white bg-[#0e0e0e] md:px-0 px-4"
        dir={direction}
      >
        <footer className="my-5 max-container">
          <span dir={direction} className="text-sm text-white md:text-base">
            {t("footer_copyright")}
            <a
              onClick={() => navigateWithLang("/")}
              className="text-white duration-300 cursor-pointer hover:underline hover:text-custom-yellow"
            >
              {t("footer_brand")}{" "}
            </a>
            {t("footer_rights")}
            <a
              href="https://target-group.org/"
              target="_blank"
              className="mx-1 text-white duration-300 hover:underline hover:text-custom-yellow"
            >
              {t("footer_developer")}
            </a>
          </span>
        </footer>
      </div>

      <div
        className={`fixed z-30 bottom-4 md:bottom-7 flex flex-col gap-3 ${
          direction === "ltr" ? "right-4 md:right-7" : "left-4 md:left-7"
        }`}
      >
        {/* WhatsApp */}
        <a
          href="https://api.whatsapp.com/send/?phone=%2B905331586084&text&type=phone_number&app_absent=0"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center w-12 h-12 transition duration-300 bg-green-500 rounded-full shadow-lg hover:bg-green-600"
        >
          <FontAwesomeIcon icon={faWhatsapp} className="w-6 h-6 text-white" />
        </a>

        {/* Scroll to Top */}
        <button
          className="flex items-center justify-center w-12 h-12 transition duration-300 rounded-full shadow-lg bg-custom-yellow hover:bg-yellow-400"
          onClick={scrollToTop}
        >
          <ChevronUpIcon className="w-6 h-6 text-black" />
        </button>
      </div>

      <SubscriptionPopup
        isVisible={showPopup}
        type={popupType}
        onClose={() => setShowPopup(false)}
      />
    </div>
  );
}
